export default function PageProfile_Admin() {
  return <></>;
}
